import { Newspaper } from 'lucide-react';
import { NewsCard } from '../components/news/NewsCard';
import { useEffect, useState } from 'react';
import type { NewsItem } from '../types';
import { Helmet } from 'react-helmet-async';
import { fetchNews } from '../services/newsApi';

export function News() {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadNews = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchNews();
        setNews(data);
      } catch (err) {
        setError('Failed to load news');
        console.error('Error loading news:', err);
      } finally {
        setLoading(false);
      }
    };

    loadNews();
  }, []);

  return (
    <>
      <Helmet>
        <title>Nyheter | Aker Stadion og Molde FK</title>
        <meta 
          name="description" 
          content="Siste nyheter fra Aker Stadion og Molde FK. Hold deg oppdatert på kamper, arrangementer, stadionoppgraderinger og andre viktige hendelser."
        />
      </Helmet>
      <div className="min-h-screen bg-gray-100">
        <div className="bg-[#2173B9] text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-4">
              <Newspaper className="w-8 h-8" />
              <h1 className="text-3xl font-bold">Nyheter fra Aker Stadion</h1>
            </div>
            <p className="text-lg opacity-90">
              Siste oppdateringer og nyheter fra stadion
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="bg-white rounded-lg shadow-lg animate-pulse">
                  <div className="h-48 bg-gray-200 rounded-t-lg" />
                  <div className="p-6">
                    <div className="h-6 bg-gray-200 rounded mb-4" />
                    <div className="h-4 bg-gray-200 rounded mb-2" />
                    <div className="h-4 bg-gray-200 rounded w-2/3" />
                  </div>
                </div>
              ))}
            </div>
          ) : error ? (
            <div className="text-center py-8 text-gray-500">
              {error}
            </div>
          ) : news.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              Ingen nyheter tilgjengelig
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {news.map((newsItem) => (
                <NewsCard key={newsItem.id} news={newsItem} />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
